import { faEmptySet } from '@fortawesome/pro-regular-svg-icons';

import { Container, Icon } from './styled';

type EmptyStateProps = {
    message: string;
};

export function EmptyState({ message }: EmptyStateProps): JSX.Element {
    return (
        <Container>
            <Icon icon={faEmptySet} aria-hidden="true" />
            {message}
        </Container>
    );
}
